.content {
  z-index: var(--z-popover);
  min-width: 200px;
  max-width: min(320px, calc(100vw - var(--space-4)));
  padding: var(--space-1);
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow-lg);
  animation: appear var(--duration-fast) var(--ease-standard);
}

.item {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: var(--control-md);
  padding: 0 var(--space-3);
  border-radius: var(--radius-sm);
  color: var(--color-text);
  font-size: var(--text-md);
  cursor: pointer;
  outline: none;
  user-select: none;
}

.item[data-highlighted] {
  background: var(--color-surface-hover);
}

.item[data-disabled] {
  opacity: 0.45;
  cursor: not-allowed;
}

.danger {
  color: var(--color-danger-text);
}

.label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.separator {
  height: var(--border-width);
  margin: var(--space-1) var(--space-2);
  background: var(--color-border);
}

@keyframes appear {
  from {
    opacity: 0;
    transform: scale(0.97);
  }
}
